// videocards strings (ar). Machine-drafted — review with a native speaker before launch.
const videocards = {
	videocards: {
		// ===== List page (index.tsx) =====
		helmetList: 'بطاقات الفيديو | CardClan',
		helmetDetails: 'تفاصيل بطاقة الفيديو | CardClan',
		backToVideoCards: 'العودة إلى بطاقات الفيديو',
		title: 'بطاقات الفيديو',
		subtitle: 'أنشئ وأدر بطاقات التهنئة بالفيديو',
		createVideoCard: 'إنشاء بطاقة فيديو',

		// Upgraded success banner
		bannerStackAdded: 'تمت إضافة الحزمة',
		bannerActivated: 'تم التفعيل',
		upgradedBanner: 'عرض مدى الحياة %{state}! لديك الآن %{cards} بطاقة فيديو و%{minutes} دقيقة عرض شهريًا.',

		// Workspace disabled
		workspaceDisabledAlert: 'بطاقات الفيديو معطلة لمساحة العمل هذه. تواصل مع مسؤول مساحة العمل.',
		workspaceDisabledBanner: 'بطاقات الفيديو معطلة لمساحة العمل هذه. تواصل مع مسؤول مساحة العمل لتفعيلها.',

		// Get Started modal
		getStartedTitle: 'ابدأ الآن',
		getStartedSubtitle: 'أعدّ لوحة بطاقة الفيديو الخاصة بك.',
		occasionLabel: 'المناسبة',
		occasionPlaceholder: 'اكتب أو اختر مناسبة...',
		loading: 'جارٍ التحميل...',
		noMatchEnter: 'لا توجد نتائج مطابقة — اضغط Enter لاستخدام "%{input}"',
		noCategories: 'لم يتم العثور على فئات',
		recipientFirstName: 'الاسم الأول للمستلم',
		firstNamePlaceholder: 'مثال: سارة',
		lastName: 'اسم العائلة',
		lastNamePlaceholder: 'اختياري',
		boardTitle: 'عنوان اللوحة',
		boardTitlePlaceholder: 'يتم إنشاؤه تلقائيًا من المناسبة والاسم',
		themePreview: 'السمة: %{occasion} — %{font}',
		cancel: 'إلغاء',
		creating: 'جارٍ الإنشاء...',
		createBoard: 'إنشاء اللوحة',

		// Auto-generated titles / fallbacks
		autoTitleHappyOccasionName: '%{occasion} سعيد يا %{name}!',
		autoTitleHappyOccasion: '%{occasion} سعيد!',
		autoTitleForName: 'إلى %{name}',
		untitledVideoCard: 'بطاقة فيديو بدون عنوان',

		// ===== Cards list (VideoCardsList.tsx) =====
		deleteConfirmTitle: 'حذف بطاقة الفيديو؟',
		deleteConfirmText: 'سيؤدي هذا إلى حذف بطاقة الفيديو هذه وجميع مساهماتها نهائيًا.',
		delete: 'حذف',
		noVideoCardsYet: 'لا توجد بطاقات فيديو بعد',
		createFirstVideoCard: 'أنشئ أول بطاقة فيديو لك للبدء',
		videoCardBadge: 'بطاقة فيديو',
		copied: 'تم النسخ!',
		copyInviteLink: 'نسخ رابط الدعوة',
		due: 'الاستحقاق: %{date}',

		// ===== Usage bar (VideoCardUsageBar.tsx) =====
		progressVideoCards: 'بطاقات الفيديو',
		progressRenderMinutes: 'دقائق العرض',
		tierFree: 'مجاني',
		tierLtd: 'عرض مدى الحياة',
		upgrade: 'ترقية',
		stackMore: 'إضافة حزم',

		// ===== Detail (VideoCardDetail.tsx) =====
		detailHelmetFallback: 'بطاقة فيديو',
		statusSent: 'مُرسلة',
		statusProcessing: 'قيد المعالجة',
		statusScheduled: 'مجدولة',
		statusDraft: 'مسودة',
		tileSingular: 'مربّع',
		tilePlural: 'مربّعات',
		submissionSingular: 'مساهمة',
		submissionPlural: 'مساهمات',
		editBoard: 'تعديل اللوحة',
		deliveryModeVideo: 'فيديو',
		deliveryModeBoard: 'لوحة',
		preview: 'معاينة %{mode}',
		sentNoEdit: 'تم إرسال هذه البطاقة ولم يعد بالإمكان تعديلها.',
		scheduledForPrefix: 'مجدولة في',
		futureDate: 'تاريخ مستقبلي',
		atLabel: 'الساعة',
		cancelSchedule: 'إلغاء الجدولة',

		// Tabs
		tabContent: 'المحتوى والعرض',
		tabSettings: 'الإعدادات',
		tabDelivery: 'التسليم',

		// Content & render
		latestRenderedVideo: 'أحدث فيديو معروض',
		reRender: 'إعادة العرض',
		downloadMp4: 'تنزيل MP4',
		renderingFailed: 'فشل العرض. يرجى المحاولة مرة أخرى.',
		renderVideo: 'عرض الفيديو',
		boardTilesHeading: 'مربّعات اللوحة (%{count})',
		tileBreakdown: '%{videos} فيديو، %{texts} نص، %{images} صورة، %{gifs} صورة متحركة.',
		dragToReorderTiles: ' اسحب لإعادة الترتيب.',
		noBoardTiles: 'لا توجد مربّعات في اللوحة بعد. افتح المحرر أو شارك رابط الدعوة.',
		videoBadge: 'فيديو',
		creator: 'المنشئ',
		videoSubmissionsHeading: 'مساهمات الفيديو (%{count})',
		dragReorderRenderSeq: 'اسحب لإعادة الترتيب. يحدد الترتيب تسلسل العرض.',

		// Render steps & errors
		stepExporting: 'جارٍ تصدير لقطات الصفحة...',
		stepStarting: 'جارٍ بدء العرض...',
		stepQueued: 'في قائمة الانتظار...',
		stepProcessing: 'جارٍ المعالجة... %{progress}%',
		errRenderingFailed: 'فشل العرض',
		errLostConnection: 'فُقد الاتصال بتقدّم العرض',
		errTimeout: 'انتهت مهلة العرض بعد 10 دقائق',
		errRenderLimit: 'تم بلوغ حد العرض. قم بترقية خطتك للحصول على مزيد من دقائق العرض.',
		errFailedStart: 'تعذّر بدء العرض',

		// Save / status messages
		saved: 'تم الحفظ!',
		failedToSave: 'فشل الحفظ',
		scheduleCancelled: 'تم إلغاء الجدولة',
		selectFutureDate: 'يرجى اختيار تاريخ ووقت مستقبليين',
		enterRecipientEmail: 'يرجى إدخال بريد المستلم الإلكتروني',
		scheduledMsg: 'تمت الجدولة!',

		// Settings tab
		contributionSettings: 'إعدادات المساهمة',
		submissionDeadline: 'الموعد النهائي للمساهمة',
		submissionDeadlineHint: 'بعد هذا التاريخ، لن يتمكن المساهمون من إضافة محتوى',
		maxClipDuration: 'الحد الأقصى لمدة المقطع',
		maxClipDurationHint: 'الحد الأقصى لطول مقطع الفيديو لكل مساهم',
		inviteMessage: 'رسالة الدعوة',
		inviteMessageHint: 'رسالة مخصصة تظهر للمساهمين على صفحة اللوحة',
		inviteMessagePlaceholder: 'مثال: سجّل رسالة عيد ميلاد لسارة!',
		deliveryFormat: 'صيغة التسليم',
		deliveryFormatHint: 'كيف يجب أن يشاهد المستلم هذه البطاقة؟',
		interactiveBoard: 'لوحة تفاعلية',
		interactiveBoardHint: 'يرى المستلم لوحة المربّعات الحية مع المؤثرات',
		renderedVideo: 'فيديو معروض',
		renderedVideoHint: 'يتلقى المستلم مجموعة فيديو بصيغة MP4',
		saving: 'جارٍ الحفظ...',
		saveSettings: 'حفظ الإعدادات',

		// Delivery tab
		cardSent: 'تم إرسال البطاقة',
		cardDeliveredTo: 'تم تسليم هذه البطاقة إلى %{recipient}.',
		theRecipient: 'المستلم',
		senderEmail: 'بريد المُرسِل',
		sendFrom: 'الإرسال من',
		defaultCardClan: 'الافتراضي (CardClan)',
		senderEmailHint: 'اختر عنوان البريد الإلكتروني الذي ستُرسَل منه البطاقة.',
		recipient: 'المستلم',
		emailLabel: 'البريد الإلكتروني',
		nameLabel: 'الاسم',
		recipientNamePlaceholder: 'اسم المستلم',
		schedule: 'الجدولة',
		sendDateTime: 'تاريخ ووقت الإرسال',
		sendDateTimeHint: 'اختر موعد تسليم البطاقة. اتركه فارغًا للإرسال يدويًا.',
		autoRenderSend: 'العرض والإرسال تلقائيًا في الوقت المجدول',
		autoRenderSendHint: 'سيتم عرض الفيديو وإرساله بالبريد الإلكتروني تلقائيًا عند حلول الموعد.',
		autoRenderSendTag: '(عرض وإرسال تلقائي)',
		shareLinks: 'روابط المشاركة',
		inviteContributors: 'دعوة المساهمين',
		viewCardLabel: 'عرض البطاقة',
		copy: 'نسخ',
		scheduling: 'جارٍ الجدولة...',
		scheduleSend: 'جدولة الإرسال',
		save: 'حفظ',
		sending: 'جارٍ الإرسال...',
		sendNow: 'إرسال الآن',
		sentSuccessfully: 'تم الإرسال بنجاح!',
		failedToSend: 'فشل الإرسال. يرجى المحاولة مرة أخرى.',

		// ===== Upgrade (VideoCardsUpgrade.tsx) =====
		upgradeHelmet: 'ترقية بطاقات الفيديو | CardClan',
		limitedTimeOffer: 'عرض لفترة محدودة',
		upgradeIntro: 'ارتقِ باحتفالاتك إلى مستوى جديد مع بطاقات الفيديو المعروضة. نظرًا لتكاليف الحوسبة، فإن عرض الفيديو له حدود استخدام.',
		planFree: 'مجاني',
		foreverFree: 'مجاني إلى الأبد',
		free2Cards: 'بطاقتا فيديو / شهريًا',
		board10Items: '10 عناصر لوحة / بطاقة',
		free20Min: '20 دقيقة معروضة / شهريًا',
		currentPlan: 'الخطة الحالية',
		freeTier: 'المستوى المجاني',
		lifetimeDeal: 'عرض مدى الحياة',
		perStack: '/ حزمة',
		oneTimePayment: 'دفعة واحدة، اجمع حتى %{max}x',
		currentPlanBadge: 'الخطة الحالية',
		bestValue: 'أفضل قيمة',
		stackSingular: 'حزمة',
		stackPlural: 'حزم',
		yourCurrentPlan: 'خطتك الحالية (%{count}x %{stacks})',
		planLimits: '%{cards} بطاقة فيديو / شهريًا · %{minutes} دقيقة عرض / شهريًا',
		ltdCardsPerStack: 'بطاقة فيديو / شهريًا لكل حزمة',
		ltdMinutesPerStack: 'دقيقة معروضة / شهريًا لكل حزمة',
		benefitNoFees: 'بدون رسوم متكررة',
		benefitLifetime: 'وصول مدى الحياة',
		benefitPriority: 'عرض بأولوية',
		benefitEarly: 'سعر المستخدمين الأوائل',
		addStacksLabel: 'إضافة حزم:',
		stacksLabel: 'الحزم:',
		maxMore: '(بحد أقصى %{count} إضافية)',
		afterPurchase: 'بعد الشراء سيكون لديك:',
		processing: 'جارٍ المعالجة...',
		addStacksBtnSingular: 'إضافة %{count} حزمة',
		addStacksBtnPlural: 'إضافة %{count} حزم',
		getStacksBtnSingular: 'احصل على %{count} حزمة',
		getStacksBtnPlural: 'احصل على %{count} حزم',
		maxStacksReached: 'تم بلوغ الحد الأقصى للحزم (%{count}/%{max})',
	},
};
export default videocards;
